import type { UUID } from "@/core/types";

export const acuityKeys = {
  approvers: () => [...acuityKeys.base, "approvers"] as const,
  base: ["acuity"] as const,
  current: (patientId: string) => [...acuityKeys.base, patientId, "current"] as const,
  resolution: (patientId: UUID) => [...acuityKeys.base, patientId, "resolution"] as const,
} as const;
